import { Button, Drawer } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import useLang from "../../../../hooks/useLang";
import { getMobileView } from "../../../../redux/slices/isMobile";
import Appointments from "../../appointments";

const DrawerBody = styled.div`
  & .ant-list-item {
    &:last-child {
      border-bottom: 1px solid #f1ecec;
    }
  }
`;

const DrawerFooter = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  border-top: 1px solid rgb(232, 232, 232);
  z-index: 999;
`;

const AppointmentModal = props => {
  const {
    lead = null,
    openAppointmentDrawer = false,
    setOpenDrawer,
    onClick,
    leadOpportunities,
    handleLeadDetailProfile,
    eventId,
    assignedUserId = null,
    refetchLeads,
    refreshLeadListData,
    selectedOppTypeId = null,
  } = props;

  const [lang] = useLang();
  const isMobileView = useSelector(state => getMobileView(state));
  return (
    <Drawer
      title={`${lang.addAppointmentFor} ${lead?.fullName || ""}`}
      placement="right"
      closable
      width={isMobileView ? "100%" : "95%"}
      onClose={() => setOpenDrawer(false)}
      open={openAppointmentDrawer}
    >
      <DrawerBody>
        <Appointments
          lead={lead}
          onBackClick={() => setOpenDrawer(false)}
          onClick={onClick}
          leadOpportunities={leadOpportunities}
          handleLeadDetailProfile={handleLeadDetailProfile}
          eventId={eventId}
          assignedUserId={assignedUserId}
          refetchLeads={refetchLeads}
          refreshLeadListData={refreshLeadListData}
          selectedOppTypeId={selectedOppTypeId}
        />
      </DrawerBody>
    </Drawer>
  );
};

export default AppointmentModal;
